import {
  HttpHandlerFn,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse,
  HttpEvent,
} from '@angular/common/http';
import { Observable, tap, catchError } from 'rxjs';
import { throwError } from 'rxjs';

export function tokenExpiredInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  return next(req).pipe(
    tap((event) => {
      if (event instanceof HttpResponse) {
        // Check headers case-insensitively
        const headers = event.headers;
        const tokenExpired = headers.get('Token-Expired') || headers.get('token-expired') || headers.get('TOKEN-EXPIRED');
        if (tokenExpired) {
          console.warn('Token has expired, clearing localStorage and reloading');
          localStorage.clear();
          window.location.reload();
        }
      }
    }),
    catchError((error: HttpErrorResponse) => {
      // Check headers in error responses
      const headers = error.headers;
      const tokenExpired = headers.get('Token-Expired') || headers.get('token-expired') || headers.get('TOKEN-EXPIRED');
      if (tokenExpired) {
        console.warn('Token has expired in error response, clearing localStorage and reloading');
        localStorage.clear();
        window.location.reload();
      }
      return throwError(() => error);
    })
  );
}